import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';
import { FlexBox, FlexBoxCenter } from '@ecp/common/src/layouts/flex/styled';
import { radioClassNames } from '@ecp/common/src/components/unstyled/input/RadioUnstyled';
import PeriodGroup from '@ecp/common/src/components/periodSearch/PeriodRadioGroup';

export const defaultPeriods = [
  { name: '오늘', value: '1-days' },
  { name: '1주일', value: '1-weeks' },
  { name: '1개월', value: '1-months' },
  { name: '3개월', value: '3-months' },
  { name: '6개월', value: '6-months' },
  { name: '1년', value: '12-months' },
  { name: '전체', value: 'all' },
];
const PeriodRadioGroup = ({ periods, onClick, ...props }) => {
  return (
    <PeriodGroup
      periods={periods}
      onClick={onClick}
      rootComponent={Wrapper}
      periodItemButton={PeriodItemButton}
      {...props}
    />
  );
};

PeriodRadioGroup.propTypes = {
  periods: PropTypes.array,
  onClick: PropTypes.func,
};

PeriodRadioGroup.defaultProps = {
  periods: defaultPeriods,
  onClick: () => {},
};

const Wrapper = styled(FlexBox)`
  height: 28px;
  width: fit-content;

  & > label:first-child > div:before {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  & > label:last-child > div:before {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
`;

const PeriodItemButton = styled(FlexBoxCenter)`
  width: max-content;
  height: 26px;
  font-weight: ${boTheme.font.weight.regular};
  font-size: ${boTheme.font.size.small};
  line-height: 110%;
  padding: 4px 7px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${boTheme.color.sub10};
  position: relative;
  color: ${boTheme.color.sub1};

  &:before {
    border: 1px solid ${boTheme.color.sub6};
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
  }

  &:hover {
    background: ${boTheme.color.sub6};
    &:before {
      border: 1px solid ${boTheme.color.page5};
      content: '';
      position: absolute;
      height: 100%;
      width: calc(100% - 1px);
      z-index: 2;
      left: -1px;
    }
  }

  &.${radioClassNames.disabled} {
    cursor: default;
    background: ${boTheme.color.sub8};
    &:hover {
      background: ${boTheme.color.hover3};
      &:before {
        border: 1px solid ${boTheme.color.page5};
      }
    }
  }

  &.${radioClassNames.checked} {
    background: ${boTheme.color.page3};

    &:before {
      border: 1px solid ${boTheme.color.page2};
      content: '';
      position: absolute;
      height: 100%;
      width: calc(100% - 1px);
      z-index: 2;
      left: -1px;
    }

    &:hover {
      background: ${boTheme.color.hover2};
      &:before {
        border: 1px solid ${boTheme.color.page4};
      }
    }
  }
`;

export default PeriodRadioGroup;
